import React from 'react';
import { PrintableMapShopFinder } from './PrintableMapShopFinder';
import '../pages/printable-map-shell.css';

/**
 * What to do with the PDF, plus a Maps search for nearby retail shops.
 * Yona does not take payment for the print.
 */
export function PrintableMapPrintGuidance({ landCentroid }) {
  return (
    <div className="pm-guidance" data-testid="pm-print-guidance">
      <div className="pm-mono-label">How to print</div>
      <ol className="pm-guidance__list">
        <li>
          Print at <strong>100% / actual size</strong>. Do not use “fit to page” —
          that silently rescales the map.
        </li>
        <li>
          Ask for a poster print at the size on the sheet, on matte or satin paper.
          Matte does not glare on a clubhouse wall.
        </li>
        <li>
          Take the file to any local print shop. Same-day options include Staples,
          FedEx Office, and Office Depot; a specialist lab gives better paper if
          you care.
        </li>
      </ol>
      <PrintableMapShopFinder landCentroid={landCentroid} />
    </div>
  );
}
